import { Injectable } from '@angular/core';
import { BonusType } from 'src/app/core/services/user/data/user-bonuses.data';
import { NotificationType } from 'src/app/core/store/notification.store';

@Injectable({
  providedIn: 'root',
})
export class NotificationFieldsResolverService {
  public async resolveNotificationFields(notification: NotificationType | any) {
    if (!notification) {
      return;
    }
    if (![BonusType.FREESPIN, BonusType.CASH, BonusType.LOOTBOX].some((type) => type === notification.type)) {
      const actionLabel = notification?.ButtonName || notification?.BtnText || notification?.buttonText || notification?.actionLabel;

      return {
        ...notification,
        title: notification?.Title || notification?.title,
        description: notification?.Task || notification?.Description || notification?.description,
        image: notification?.Image || notification?.Img || notification?.image,
        id: notification?.slug || notification?.id,
        link: notification?.link || notification?.Link || notification?.BtnLink || '/offers/' + notification?.slug,
        actionLabel: actionLabel || 'btn.open',
        actionTranslateNeeded: notification?.actionTranslateNeeded ?? !actionLabel,
        isPinned: !!notification?.IsPinned || !!notification?.isPinned,
        isDeleted: notification?.isDeleted,
      };
    } else {
      return await this._resolveNotificationFieldsByType(notification);
    }
  }

  private async _resolveNotificationFieldsByType(notification: any) {
    switch (notification.type) {
      case BonusType.FREESPIN:
        return this._resolveFieldsForFs(notification);
      case BonusType.CASH:
        return this._resolveFieldsForCashBonus(notification);
      case BonusType.LOOTBOX:
        return this._resolveFieldsForLootbox(notification);
      default:
        return {
          title: 'Unknown Notification',
          description: '',
          image: '',
          id: notification?.uid || 'unknown',
          link: '/account',
          actionLabel: 'btn.open',
          actionTranslateNeeded: true,
          isDeleted: false,
          isPinned: false,
          deleteTimestamp: null,
        };
    }
  }

  private async _resolveFieldsForFs(notification: any): Promise<NotificationType> {
    return {
      title: 't.free-spins',
      description: 't.notify-freespins-desc',
      descKeys: { count: notification.balance },
      image: '/assets/svg/notifications/fs.svg',
      id: notification?.id,
      link: '/account/',
      actionLabel: 'btn.get-bonus',
      actionTranslateNeeded: true,
      isDeleted: false,
      isPinned: false,
      deleteTimestamp: this._addOneDayTimestamp(),
      translateNeeded: true,
    };
  }

  private _resolveFieldsForLootbox(notification: any): NotificationType {
    return {
      title: 't.lootbox',
      description: 't.notify-lootbox-desc',
      descKeys: null,
      image: '/assets/svg/notifications/lootbox.svg',
      id: notification?.id,
      link: '/account/',
      actionLabel: 'btn.get-bonus',
      actionTranslateNeeded: true,
      isDeleted: false,
      isPinned: false,
      deleteTimestamp: this._addOneDayTimestamp(),
      translateNeeded: true,
    };
  }

  private _resolveFieldsForCashBonus(notification: any): NotificationType {
    return {
      title: 'link.bonuses',
      description: 't.notify-bonuses-desc',
      descKeys: { bonus: notification.title },
      image: '/assets/svg/notifications/cash.svg',
      id: notification?.id,
      link: '/account',
      actionLabel: 'btn.get-bonus',
      actionTranslateNeeded: true,
      isDeleted: false,
      isPinned: false,
      deleteTimestamp: this._addOneDayTimestamp(),
      translateNeeded: true,
    };
  }

  private _addOneDayTimestamp() {
    const now = new Date();
    const endOfDayUTC = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 23, 59, 59, 999));

    return endOfDayUTC.getTime();
  }
}
